import {Component, attr} from "../Component";
import {element} from "../CustomElement";

import {Dialog} from "../flipp-dialog/Dialog";
import {AuthProvider, ToastLevel} from "../../definitions/CommonDefinitions";

import {inject} from "../../services/di";
import {AuthenticationService} from "../../services/AuthenticationService";
import {EventService} from "../../services/EventService";
import {AccountsService} from "../../services/AccountsService";
import {LocationService} from "../../services/LocationService";
import {AnalyticsService} from "../../services/AnalyticsService";
import {ConfigService} from "../../services/ConfigService";
import {ToastService} from "../../services/ToastService";
import {LoginSource} from "../../services/definitions/IAnalyticsService";
import {i18n} from "../../i18n/I18n";

export type LoginContext = "coupon_page" | "coupon_details" | "topbar" | "flyer_item" | "share_dialog" | "shopping_list";

interface LoginButtonProps extends JSX.HTMLProps {
	provider: AuthProvider;
	context: LoginContext;
}

@element("flipp-login-button")
export class LoginButton extends Component<LoginButtonProps, {}> {

	@inject auth: AuthenticationService;
	@inject eventService: EventService;
	@inject accounts: AccountsService;
	@inject location: LocationService;
	@inject analytics: AnalyticsService;
	@inject config: ConfigService;
	@inject toast: ToastService;

	@attr provider: AuthProvider;
	@attr context: LoginContext;

	refs: {
		emailConfirm: Dialog
	};

	render() {
		const lang = this.location.acceptsLocale("fr") ? "fr" : "en";
		const signinImg = this.provider === AuthProvider.GOOGLE ?
			`signin-google-${lang}.png` :
			`signin-facebook-${lang}.png`;
		return <span>
				<button classList={{
					"facebook": this.provider === AuthProvider.FACEBOOK,
					"google": this.provider === AuthProvider.GOOGLE
				}} onClick={this.handleLogin_}>
					<img src={`https://f.wishabi.net/creative/Distribution/images/${signinImg}`} alt="" />
				</button>
			</span>;
	}

	private handleLogin_ = (e: Event) => {
		const target = this.context === "coupon_page" ? window : this;
		this.auth.login(this.provider, target).then(() => {
			this.analytics.setAccountGuid(this.auth.user.token.user_id);
			this.eventService.fireAuthEvent("login", null, target);
			this.toast.fireToastEvent(i18n("signin_success"), ToastLevel.OK, true, target);
			this.analytics.trackSignin(this.auth.user.token.user_id, this.provider, this.getLoginSource_());
			this.eventService.redirectToForm();
		}).catch((e: Error) => {
			this.toast.fireToastEvent(i18n("signin_error"), ToastLevel.ERROR, true, target);
			this.eventService.fireAuthEvent("error", e.message, target);
		});
	}

	private getLoginSource_ = (): LoginSource => {
		switch (this.context) {
			case "coupon_page": return LoginSource.CouponPage;
			case "topbar": return LoginSource.Topbar;
			case "flyer_item": return LoginSource.FlyerItem;
			case "coupon_details": return LoginSource.CouponDetails;
			case "share_dialog": return LoginSource.ShareDialog;
			case "shopping_list": return LoginSource.ShoppingList;
		}
	}
}
